import service from '@/utils/server';

const modName='/bd/accessoryAppointment/';
//查询方法
export const pageInfo = data => {
  return service({
    url: modName + 'pageInfo',
    method: 'post',
    data
  });
};

export const purchOrderPageInfo = data => {
  return service({
    url: modName + 'initSubmit',
    method: 'post',
    data
  });
};

export const add = data => {
  return service({
    url: modName + 'submit',
    method: 'post',
    data
  });
};

export const unloadConfigExport = data => {
  let config = {
    responseType: "blob"
  };
  return service( {
    ...config,
    url: modName + 'unloadConfigExport',
    method: 'post',
    data
  });
};

//取消
export const appointmentPlanCancel = data => {
  return service({
    url: modName + 'cancel',
    method: 'post',
    data
  });
}

//详情
export const detail = data => {
  return service({
    url: modName + 'detail',
    method: 'post',
    data
  });
}

//编辑
export const edit = data => {
  return service({
    url: modName + 'edit',
    method: 'post',
    data
  });
}







// WEBPACK FOOTER //
// ./src/page/bd/accessory/appointmentPlan/api/index.js